import React, { lazy, Suspense } from 'react'
import { Switch, Route, Redirect, NotFound } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import { useFeatureFlag } from '@fs/zion-flags'
import { geoData } from '@fs/zion-config'
import TreeOverviewPageSkeleton from './components/family-tree/TreeOverviewPage/TreeOverviewPageSkeleton'
import FamilyInterviewQuestionsPage from './components/family-tree/FamilyInterviewQuestionsPage/FamilyInterviewQuestionsPage'

const TreeTemplatesPage = lazy(() => import('./pages/philippines/TreeTemplatesPage/TreeTemplatesPage'))
const TreeOverviewPage = lazy(() => import('./components/family-tree/TreeOverviewPage/TreeOverviewPage'))
const PhilippinesTreeOverviewPage = lazy(
  () => import('./components/family-tree/TreeOverviewPage/PhilippinesTreeOverviewPage')
)

export default function App() {
  const isPhilippines = useFeatureFlag('homelands_treeOverview_philippines')?.isOn && geoData?.country === 'PH'

  return (
    <ErrorBoundary>
      <Suspense fallback={<TreeOverviewPageSkeleton />}>
        <Switch>
          {isPhilippines && <Redirect exact from="/" to="/philippines" />}
          <Route exact path="/" component={TreeOverviewPage} />
          <Route exact path="/philippines" component={PhilippinesTreeOverviewPage} />
          <Route exact path="/philippines/family-interview-questions" component={FamilyInterviewQuestionsPage} />
          <Route exact path="/philippines/tree-templates" component={TreeTemplatesPage} />
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </ErrorBoundary>
  )
}
